import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

import backgroundBox1 from '@peerless/ui-assets/images/KisokBuilder_270x220.jpg';

interface Props {
  text?: string;
}

export const CalloutBox: React.FC<Props> = props => {
  return (
    <Grid item xs={6} md={6} lg={3}>
      <Box
        sx={{
          backgroundImage: 'url(' + backgroundBox1.src + ')',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '120%',
          transition: 'background-size 0.5s ease-in-out',
          '&: hover': { backgroundSize: '150%' },
        }}
      >
        <Box
          p={2}
          sx={{
            flexGrow: 1,
            backgroundColor: 'transparent.black',
            minHeight: { xs: '120px', md: '220px' },
            maxHeight: { xs: 'auto', md: '270px' },
            minWidth: { xs: 'auto', md: '220px' },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'background-color 0.5s ease-in-out',
            '&: hover': { backgroundColor: 'transparent.red' },
          }}
        >
          <Typography variant="h3" textAlign={'center'} color={'common.white'}>
            {props.text}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};
